import { Link } from 'react-router-dom';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { API } from '../../../API';
import { toast } from 'react-toastify';
import { showRequestError } from '../../../utils/requestError';

import styles from './AdjustmentSuggestion.module.scss';

export function AdjustmentSuggestion({
  narrative,
  suggestion,
  onSuggestionApply = null,
}) {
  const { t } = useTranslation();

  if (suggestion === null) {
    return <></>;
  }

  const handleApplyClick = () => {
    // Copy: `narrative.parameters` is context state, don't mutate it in place.
    const parameters = { ...narrative.parameters };

    for (const [key, value] of Object.entries(suggestion.actions)) {
      if (key === 'start_date' || key === 'end_date' || key === 'disable_filters') {
        parameters[key] = value
      } else {
        parameters[key] = []
      }
    }

    // The PATCH is validated by the same schema as PUT: `name` and
    // `description` are required, and the parameters validator only relaxes
    // its rules when `type` / `is_manual` are present. Echo them from the
    // loaded case, as the edit page does, or the request fails with 422.
    API.fetch('PATCH', `/API/v1/narratives/${narrative.id}`, null, {
      name: narrative.name,
      description: narrative.description,
      type: narrative.type,
      is_manual: narrative.is_manual,
      on_edit: {apply_suggestion: true},
      adjustment_suggestions: null,
      parameters: parameters,
    }).then(() => {
      toast.success(t('Suggestion applied. Publications will update in a few minutes.'));
      if (onSuggestionApply) {
        onSuggestionApply();
      }
    }).catch((e) => showRequestError(e, t('Apply suggestion')));
  }

  return (
    <div className={styles.root}>
      <div>
        {suggestion.text} {t('to find')} <b>{suggestion.messages_found}</b> {t('publications')}
      </div>
      <button onClick={() => handleApplyClick()}>{t('Apply')}</button>
    </div>
  );
}
